import React, { useEffect } from 'react';
import { LatLngBoundsExpression } from 'leaflet';
import { useMap } from 'react-leaflet';

interface FitBoundsProps {
  bounds: LatLngBoundsExpression | null;
  onCenterChange: (center: [number, number]) => void;
  onZoomChange: (zoom: number) => void;
}

export const FitBounds: React.FC<FitBoundsProps> = ({ bounds, onCenterChange, onZoomChange }) => {
  const map = useMap();

  useEffect(() => {
    if (bounds) {
      // Fit bounds with padding
      map.fitBounds(bounds, {
        padding: [50, 50], // Add padding around bounds (50px on all sides)
        maxZoom: 18,       // Don't zoom in too much
        animate: true      // Animate the transition
      });

      // Update parent with new center and zoom after bounds are fitted
      const center = map.getCenter();
      const zoom = map.getZoom();
      onCenterChange([center.lat, center.lng]);
      onZoomChange(zoom);
    }
  }, [bounds, map, onCenterChange, onZoomChange]);

  return null;
};
